import React from 'react';
import './skills.css';

const skillGroups = [
    {
        title: 'Frontend Development',
        skills: [
            ['React.js', 'bx bxl-react'],
            ['Next.js', 'bx bxl-react'],
            ['JavaScript', 'bx bxl-javascript'],
            ['TypeScript', 'bx bxl-typescript'],
            ['HTML', 'bx bxl-html5'],
            ['CSS', 'bx bxs-file-css'],
            ['Bootstrap', 'bx bxl-bootstrap'],
            ['Responsive UI', 'bx bx-devices'],
            ['Razor Pages', 'bx bxs-layer']
        ]
    },
    {
        title: 'Backend Development',
        skills: [
            ['Python', 'bx bxl-python'],
            ['FastAPI', 'bx bx-fast-forward'],
            ['C#', 'bx bx-code-curly'],
            ['ASP.NET Core', 'bx bxl-microsoft'],
            ['Web API', 'bx bx-server'],
            ['MVC', 'bx bxl-microsoft'],
            ['REST APIs', 'bx bx-transfer-alt'],
            ['Pydantic', 'bx bx-check-shield'],
            ['Clean Architecture', 'bx bx-layer-plus'],
            ['Layered Architecture', 'bx bx-layer'],
            ['SOLID', 'bx bx-cube'],
            ['Object-Oriented Programming', 'bx bxs-component']
        ]
    },
    {
        title: 'Data, Search & Infrastructure',
        skills: [
            ['PostgreSQL', 'bx bxl-postgresql'],
            ['pgvector', 'bx bx-vector'],
            ['Qdrant', 'bx bx-search-alt'],
            ['SQL Server', 'bx bx-data'],
            ['T-SQL', 'bx bx-data'],
            ['MySQL', 'bx bxs-data'],
            ['SQLite', 'bx bx-data'],
            ['Redis', 'bx bx-memory-card'],
            ['Entity Framework Core', 'bx bx-layer-plus'],
            ['Dapper', 'bx bx-data'],
            ['ADO.NET', 'bx bx-layer'],
            ['LINQ', 'bx bx-code-alt'],
            ['Git', 'bx bxl-git'],
            ['Docker', 'bx bxl-docker'],
            ['Azure DevOps', 'bx bxl-microsoft'],
            ['Jira', 'bx bx-task']
        ]
    },
    {
        title: 'AI, Automation & Languages',
        skills: [
            ['RAG Systems', 'bx bx-brain'],
            ['Prompt Engineering', 'bx bx-bulb'],
            ['Function Calling', 'bx bx-code-block'],
            ['Voice Agents', 'bx bx-phone-call'],
            ['Semantic Search', 'bx bx-search'],
            ['LiveKit', 'bx bx-broadcast'],
            ['n8n', 'bx bx-network-chart'],
            ['Activepieces', 'bx bx-extension'],
            ['Webhooks', 'bx bx-link'],
            ['Telegram Bots', 'bx bxl-telegram'],
            ['Java', 'bx bxl-java'],
            ['C++', 'bx bxl-c-plus-plus'],
            ['Firebase', 'bx bxl-firebase']
        ]
    }
];

const CvSkills = () => {
    return (
        <section className="skills section" id="skills">
            <h2 className="section__title">Skills</h2>
            <span className="section__subtitle">Technical toolkit</span>

            <div className="skills__container container grid">
                {skillGroups.map((group) => (
                    <div className="skills__content" key={group.title}>
                        <h3 className="skills__title bold">{group.title}</h3>

                        <div className="skills__box">
                            {group.skills.map(([name, icon]) => (
                                <div className="skills__data" key={name}>
                                    <i className={icon}></i>
                                    <h3 className="skills__name">{name}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CvSkills;
